export default __webpack_public_path__ + "static/media/Logo.434b2846.svg";